// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-container {
  width: 100%;
  padding-top: 40px;
}
.timeline-container .timline {
  margin-top: 16px;
  height: 100%;
}
.timeline-container .timline img {
  max-height: 100%;
}
.timeline-container .custom-card {
  margin-top: 16px;
  padding: 24px;
}
.timeline-container .custom-card ul li {
  font-size: 16px;
  margin-top: 16px;
  padding-left: 16px;
  position: relative;
}
.timeline-container .custom-card ul li::before {
  content: "";
  background-color: #163B6B;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 10px;
}
.timeline-container .custom-card ul li:first-child {
  margin-top: 0;
}
.timeline-container .custom-card ul li .timeline-sublist li:first-child {
  margin-top: 16px;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .timeline-container {
    padding-left: 16px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 768px) {
  .timeline-container {
    width: 100%;
    padding-left: 0;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .timeline-container {
    padding-top: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Timeline/Timeline.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EAEA,iBAAA;AAAF;AACE;EACE,gBAAA;EACA,YAAA;AACJ;AAAI;EACE,gBAAA;AAEN;AACE;EACI,gBAAA;EACA,aAAA;AACN;AACQ;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AACV;AAAU;EACE,WAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AAEZ;AAAU;EACE,aAAA;AAEZ;AAEc;EACE,gBAAA;AAAhB;;AAQA;EACE;IACE,kBAAA;EALF;AACF;AAQA;EACE;IACE,WAAA;IACA,eAAA;EANF;AACF;AAQA;EACE;IACE,iBAAA;EANF;AACF","sourcesContent":[".timeline-container{\r\n  width: 100%;\r\n  // padding-left: 35px;\r\n  padding-top: 40px;\r\n  .timline{\r\n    margin-top: 16px;\r\n    height: 100%;\r\n    img{\r\n      max-height: 100%;\r\n    }\r\n  }\r\n  .custom-card{\r\n      margin-top: 16px;\r\n      padding: 24px;\r\n      ul{\r\n        li{\r\n          font-size: 16px;\r\n          margin-top: 16px;\r\n          padding-left: 16px;\r\n          position: relative;\r\n          &::before{\r\n            content: \"\";\r\n            background-color: #163B6B;\r\n            width: 6px;\r\n            height: 6px;\r\n            border-radius: 50%;\r\n            position: absolute;\r\n            left: 0;\r\n            top: 10px;\r\n          }\r\n          &:first-child{\r\n            margin-top: 0;\r\n          }\r\n          .timeline-sublist{\r\n            li{\r\n              &:first-child{\r\n                margin-top: 16px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n}\r\n@media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n  .timeline-container{\r\n    padding-left: 16px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 768px) {\r\n  .timeline-container{\r\n    width: 100%;\r\n    padding-left: 0;\r\n  }\r\n}\r\n@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n  .timeline-container{\r\n    padding-top: 24px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
